import {useState} from'react';
import msg from './msg.jfif';
import {toast} from 'react-toastify';
import{Link} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
function Register (){
    const[user,setUser]=useState({name:'',email:'',password:'',username:''});
    const navigate=useNavigate();
const handleChange=(e)=>{  
const {name,value}=e.target;
setUser((prev)=>({
    ...prev,
    [name]:value
}));
};
const handlesubmit=(e)=>{
    e.preventDefault();
const users=JSON.parse(localStorage.getItem('users'))||[];
if(users.find(u=>u.username=== user.username)){
    toast.error('already exists');
    return;
}
users.push(user);
localStorage.setItem('users',JSON.stringify(users));
    toast.success('Registered successfully');
setUser({name:'',email:'',password:'',username:''});
//navigate
navigate('/login');
};/*
try{
   const response= await fetch('http/get/register',{
    method:'POST',
    headers:{
        'Content-Type':'application/json'
    },
    body:JSON.stringify(user)
   });
   const data=await response.json();
console.log('data fetched',data);
}catch(err){
    console.log('internal error');
};
};
*/
return(
<form onSubmit={handlesubmit}>
<div style={{display:'flex',columnGap:'30px',paddingLeft:'250px',marginTop:'50px'}}>
<div className='coverpage' style={{padding:'20px'}}>
<img src={msg} alt='cover'style={{width:'100%'}}/>
</div>
<div  className='login_pagestyle'style={{width:'70%'}}>
<h4>Sign up</h4>
<input type='text' name='name' placeholder="Name" value={user.name}  onChange={handleChange} style={{marginTop:'12px',width:'50%',padding:'4px'}}/>
<br/>
<input type='email' name='email' placeholder="Email" value={user.email} onChange={handleChange} style={{marginTop:'12px',width:'50%',padding:'4px'}}/>
<br/>
<input type='text' name='username' placeholder="username" value={user.username} onChange={handleChange} style={{marginTop:'12px',width:'50%',padding:'4px'}}/>
<br/>
<input type='password' name='password' placeholder="password" value={user.password} onChange={handleChange} style={{marginTop:'12px',width:'50%',padding:'4px'}}/>
<br></br>
<button className='btn btn-dark' style={{marginTop:'20px'}}>Register</button>
<br></br>
<span style={{display:'inline-block',marginTop:'10px'}}>Already have an account?  </span><Link to='/login' style={{paddingLeft:'7px'}}>Log in here</Link>
</div>
    </div>
</form>
);
};
export default Register;
